module.exports = __webpack_public_path__ + "img/Mark NG Illustrationen.04947559.svg";